<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show">
                <v-toolbar dark color="blue">
                    <v-toolbar-title>Matriz de Desempeño Proveedor Interno</v-toolbar-title>
                </v-toolbar>
                <v-card-text>

                    <table border="1" width="100%">
                        <tr>
                            <th colspan="2" rowspan="2">&nbsp;</th>
                            <th colspan="18">
                                <p align="center">
                                    <font color="#000000">PROVEEDOR</font>
                                </p>
                            </th>
                        </tr>
                        <tr>
                            <th class="rotated-text">
                                <font color="#000000">Administración</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Personal y RRHH</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Comercial</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Abastecimiento</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Ing. de Obra</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Ing. de Producto</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Fabricación</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Obras y Servicios</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Adm. del SGI</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Inspección y Ensayos</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Sucursal Bs As</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">SSGG y Mantenim.</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Sistemas</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Recep. / Telefonista</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Depósito Central</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">SST y Medio Amb.</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Medicina Laboral</font>
                            </th>
                            <th class="rotated-text">
                                <font color="#000000">Control de Gestión</font>
                            </th>

                        </tr>
                        <tr>
                            <th rowspan="18" class="rotated-text">
                                <p align="center">
                                    <font color="#000000">CLIENTE</font>
                                </p>
                            </th>
                            <th>
                                <font color="#000000">Administración</font>
                            </th>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AM')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('AT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Personal y RRHH</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('BS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Comercial</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DF')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DI')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DM')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('DT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Abastecimiento</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('ED')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EF')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EM')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('EQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('ER')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('ES')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('ET')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Ing. de Obra</font>
                            </th>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FI')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('FT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Ing. de Producto</font>
                            </th>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GF')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GH')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('GT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Fabricación</font>
                            </th>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('HS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Obras y Servicios</font>
                            </th>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('ID')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IF')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IM')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('IT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Adm. del SGI</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KF')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KH')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KI')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KM')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('KT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Inspección y Ensayos</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LH')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LM')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('LT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Sucursal Bs As</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('MA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('MB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('MD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('MK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('MO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('MP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('MR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">SSGG y Mantenim.</font>
                            </th>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NH')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NI')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('NS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Sistemas</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('OA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('OB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('OK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('ON')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('OP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('OQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('OR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('OS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Recep. / Telefonista</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('PA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('PB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('PK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('PO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('PR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('PS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Depósito Central</font>
                            </th>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QF')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('QT')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">SST y Medio Amb.</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RH')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RI')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>

                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('RS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Medicina Laboral</font>
                            </th>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('SB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('SK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('SO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('SP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('SR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <th>
                                <font color="#000000">Control de Gestión</font>
                            </th>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TA')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TB')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TD')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TE')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TF')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TG')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TH')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TI')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TK')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TL')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TN')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TO')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TP')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TQ')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TR')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td>
                                <p align="center" class="MsoNormal"><v-icon large color="green darken-2"
                                        @click="editarPlanilla('TS')">
                                        mdi-check
                                    </v-icon></p>
                            </td>
                            <td bgcolor="#C0C0C0">&nbsp;</td>
                        </tr>
                    </table>
                </v-card-text>
            </v-card>
            <EditarPlanilla :visible="showEditar" :codgral="this.codgral" @close="showEditar = false">
            </EditarPlanilla>
        </v-app>
    </div>

</template>
<script>
import EditarPlanilla from "../Desempenio/Nuevoprove.vue";
export default {
    components: { EditarPlanilla },

    data: (vm) => ({
        showEditar: false,
        codgral: "",
    }),
    computed: {
        show: {
            get() {
                // this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        editarPlanilla(item) {
            this.codgral = item;
            this.showEditar = true;
        },
    }
}
</script>
<style>
table.MsoNormalTable {
    mso-style-parent: "";
    font-size: 10.0pt;
    font-family: "Times New Roman";
    /* writing-mode: tb-rl;
    transform: rotate(-180deg); */
}

table.prueba {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
}

p.MsoNormal {
    mso-style-parent: "";
    margin-bottom: .0001pt;
    font-size: 12.0pt;
    font-family: "Times New Roman";
    margin-left: 0cm;
    margin-right: 0cm;
    margin-top: 0cm;
}
</style>
<style>
.rotated-text {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
}
</style>